import type { WorkflowStatusBody } from '@/shared/api/generated/model';
import { cx } from '@/shared/lib/cx';

import styles from './Stages.module.scss';

/** Метка статуса: цветная точка и название. */
export function StageBadge({ status }: { status: WorkflowStatusBody | undefined }) {
  if (status === undefined) {
    return null;
  }

  return (
    <span className={cx(styles['badge'], styles[status.color ?? 'gray'])}>
      <span className={styles['dot']} aria-hidden="true" />
      {status.name}
    </span>
  );
}
